import { render, staticRenderFns } from "./detail-config.vue?vue&type=template&id=07050338&"
import script from "./detail-config.vue?vue&type=script&lang=js&"
export * from "./detail-config.vue?vue&type=script&lang=js&"
import style0 from "./detail-config.vue?vue&type=style&index=0&id=07050338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports